import { render } from "./Hinnakiri.vue?vue&type=template&id=1e4cd070&scoped=true"
import script from "./Hinnakiri.vue?vue&type=script&lang=js"
export * from "./Hinnakiri.vue?vue&type=script&lang=js"

import "./Hinnakiri.vue?vue&type=style&index=0&id=1e4cd070&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4cd070"]])

export default __exports__